// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.regex-field[data-v-e8ba4a4c] input{font-family:monospace}`, "",{"version":3,"sources":["webpack://./components/admin/sections/Indexing.vue"],"names":[],"mappings":"AAEE,oCACE,qBAAA","sourcesContent":["\n.regex-field {\n  :deep input {\n    font-family: monospace;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
